const SUFFIX = " — د. سارة النحّاس";

/** Article <title>: seo_title when set, else the headline; brand suffix only if it fits 65 chars. */
export function articleTitle(seoTitle: string | null | undefined, headline: string): string {
  const base = (seoTitle?.trim() || headline).trim();
  const withSuffix = base + SUFFIX;
  return [...withSuffix].length <= 65 ? withSuffix : base;
}
